export default __webpack_public_path__ + "static/media/caf.c0b7457d.png";